export const SUPPORTED_LOCALES = ['ru', 'en', 'zh-Hans'] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = 'ru';
export const LOCALE_STORAGE_KEY = 'magimp:locale';

export const LOCALE_META: Record<
  AppLocale,
  { readonly htmlLang: string; readonly dir: 'ltr' | 'rtl'; readonly intlLocale: string }
> = {
  ru: { htmlLang: 'ru', dir: 'ltr', intlLocale: 'ru-RU' },
  en: { htmlLang: 'en', dir: 'ltr', intlLocale: 'en-US' },
  'zh-Hans': { htmlLang: 'zh-Hans', dir: 'ltr', intlLocale: 'zh-Hans-CN' },
};

export function isAppLocale(value: string): value is AppLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function normalizeLocale(value: string | null | undefined): AppLocale {
  if (!value) return DEFAULT_LOCALE;
  const normalized = value.trim();
  if (isAppLocale(normalized)) return normalized;
  const lower = normalized.toLowerCase();
  if (lower === 'ru' || lower.startsWith('ru-')) return 'ru';
  if (lower === 'en' || lower.startsWith('en-')) return 'en';
  if (
    lower === 'zh' ||
    lower === 'zh-cn' ||
    lower === 'zh-sg' ||
    lower === 'zh-hans' ||
    lower.startsWith('zh-hans-')
  ) {
    return 'zh-Hans';
  }
  return DEFAULT_LOCALE;
}
